module.exports = __webpack_public_path__ + "img/ic_linkedin.19c1440d.svg";